import React, { useEffect, useState } from 'react';
import snsWebSdk from '@sumsub/websdk';
import apicalls from '../../api/apiCalls';
import { connect,useDispatch,useSelector } from 'react-redux';
import { userInfo, getkycData } from '../../reducers/configReduser';
import { useNavigate } from 'react-router-dom';
import { userManager } from 'src/authentication';
import { clearProfile } from 'src/reducers/authReducer';

const SumSub = (props) => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [sumSubConfirm, setSumSubConfirm] = useState(false);
    const menuData=useSelector((state) => state.commonData?.cardspermissionsconfig);
    const dispatch=useDispatch();
    useEffect(() => {
        setLoading(true);
        if (!props.kycData?.isKybState) {
            navigate("/sumsub");
          } else if(!menuData||menuData?.length==0){
            navigate("/accessdenied");
          }else{
            navigate(menuData[0]?.path);
          }
        launchWebSdk();
    }, [props.kycInfo]); 

    const launchWebSdk = async () => {
    try {
        setLoading(true);
        const res = await apicalls.sumsubacesstoken(props.userConfig?.tenantId, "basic-kyb");

        const token = res?.data?.token;
        if (!token) {
            console.error("SumSub Token Error: Invalid response", res);
            return;
        }

        const onMessageHandler = async (type, payload) => {
            if (type === 'idCheck.onResize') {
                window.scrollTo(0, 0);
                return;
            }

            if (type === 'idCheck.applicantStatus' && payload.reviewStatus === "completed") {
                console.log("Verification Completed:", payload);
                setSumSubConfirm(true);

                await apicalls.updateKyc(props.userConfig.tenantId);
                await props.getkycDetails(props.userConfig?.tenantId);

                redirectAfterKyc();
            }
        };

        const redirectAfterKyc = () => {
            if (!props.kycData?.isKybState) {
                navigate("/sumsub");
            } else if (!menuData || menuData.length === 0) {
                navigate("/accessdenied");
            } else {
                navigate(menuData[0]?.path);
            }
        };

        const snsWebSdkInstance = snsWebSdk.init(token, () => token)
            .withConf({
                lang: "en",
                email: props.userConfig.email,
                phone: props.userConfig.phoneNumber,
                onError: (error) => {
                    console.error('WebSDK Error:', error);
                }
            })
            .onMessage(onMessageHandler)
            .build();

        const container = document.getElementById("sumsub-websdk-container");
        if (container) {
            snsWebSdkInstance.launch('#sumsub-websdk-container');
        }

    } catch (error) {
        console.error("SumSub SDK Launch Error:", error);
    } finally {
        setLoading(false);
    }
};

    const handleLogout = () => {
        dispatch(clearProfile())
        userManager.signoutRedirect();
      }
    return (
        <div className="sumsub-container">
            <div className="flex justify-end items-center m-2">
                 <button onClick={handleLogout} className="flex bg-menubghover gap-2 p-2.5 !rounded-5 items-center justify-end logout-btn-style" >
                   <span className='icon logout cursor-pointer' title="Logout" onClick={handleLogout}></span>
                   <span className="!text-subTextColor font-medium text-base">Logout</span>
                 </button>
                </div>
            {sumSubConfirm ? (
                <div className="sumSub-confirm text-white text-center">
                    
                    <br />
                    <span className="sumSub-review">Verification Completed</span>
                    <p className="p-0" style={{ wordBreak: 'break-word' }}>
                        After SumSub completion, please refresh the page or re-login.
                    </p>
                </div>
            ) : (
                <div id="sumsub-websdk-container" style={{ width: '100%', height: '100%' }}></div>
            )}

            {!sumSubConfirm && !loading && !props.kycInfo?.isKybState && (
                <div className="info-text text-center">
                    <p>SumSub verification is in progress...</p>
                </div>
            )}
        </div>
    );
};

const mapStateToProps = ({ oidc, configData }) => ({
    userConfig: oidc.user?.currentUser,
    user: oidc.user,
    kycInfo: configData?.kycData
});

const mapDispatchToProps = (dispatch) => ({
    userInformation: (info) => dispatch(userInfo(info)),
    getkycDetails: (tenantId) => {
        dispatch(getkycData(tenantId));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(SumSub);
